import React, { useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {rater_layer_list} from './Const'
import { useSelector, useDispatch } from 'react-redux';
import { setGlobalRaster } from '../../../redux/actions/mapaction';
import { setRasterRoi } from '../../../redux/actions/mapaction';
import Typography from '@mui/material/Typography';
import { bgColors } from '../../utils/bgColor';
import Divider from '@mui/material/Divider';

export default function RasterlayerRadiobutton(){
  const activeGlobalRaster = useSelector(state => state.mapreducer.globalraster)
  const asctiveRoi = useSelector(state => state.mapreducer.rasterroi)
  const rater_layer_roi = [
    'UserROI',
    'Global'
    ]
  const dispatch = useDispatch()
  const [value, setValue] = React.useState(activeGlobalRaster);
  useEffect(()=> {
    dispatch(setGlobalRaster(value))
  },[value])

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const [rasterroi, setRasterroi] = React.useState(asctiveRoi);
  const HandleRoiChange = (event) => {
    setRasterroi(event.target.value);
  };
  useEffect(()=> {
    dispatch(setRasterRoi(rasterroi))
  },[rasterroi])

return (
  // <Card style = {{maxHeight:'20%', overFlow: 'scroll' }}>
    <FormControl >

    {/* <FormLabel id="Raster-group-label"> global local</FormLabel> */}
    <RadioGroup
        row
        aria-labelledby="region of interest"
        name="Raster-group-region of interest"
        value={rasterroi}
        onChange={HandleRoiChange}
      >
           {rater_layer_roi.map((item,index)=> 
            <FormControlLabel value={item} control={<Radio />} label={
              
              <Typography 
        sx ={{
            fontSize: 14, 
             fontWeight:'bold',
             fontFamily:'serif',
             padding:'0.25rem',
             color:bgColors.grey_800
             }}
          >{item}
        </Typography> 

            }
            key = {`${item}_${index}_radio`}
            />
            )
        }
  
      </RadioGroup>
    

    <FormLabel id="Raster-group-label">

    
    <Typography 
        sx ={{
            fontSize: 16, 
             fontWeight:'bold',
             fontFamily:'serif',
             padding:'0.25rem',
             color:bgColors.font_blue
             }}
          >{"Active layer"}
        </Typography> 
      <Divider sx = {{background:bgColors.blue_300 , borderBottomWidth: '2px'}}/>
    </FormLabel>
    <Grid container spacing={1} display='flex' padding={5} direction={"column"}>
    <RadioGroup
        aria-labelledby="Raster-group-label"
        name="Raster-group"
        value={value}
        onChange={handleChange}
    > 
        {rater_layer_list.map((item,index)=> 
            <FormControlLabel value={item} control={<Radio />} label={
              <Typography 
              sx ={{
                  fontSize: 16, 
                  //  fontWeight:'bold',
                   fontFamily:'serif',
                   padding:'0.25rem',
                   color:bgColors.grey_800
                   }}
                >{item}
              </Typography> 
              
              // item
            
            
            }
            key = {`${item}_${index}_radio`}
            />
            )
        }
    </RadioGroup>
    </Grid>
    </FormControl>
);
}
